import { createFileRoute } from "@tanstack/react-router"
import SignUp from "@/app/signup/page"

export const Route = createFileRoute("/signup/$authCode")({
  component: RouteComponent,
})

function RouteComponent() {
  const { authCode } = Route.useParams()
  return <SignUp authCode={authCode} />
}
